import api from "../../../utilidades/interceptor";
import Swal from "sweetalert2";
const url_api = process.env.REACT_APP_API_KEY

export const semaforo = async (params) => {
    try {
        const res = await api.post(`${url_api}/exp-cliente/semaforo`, params)
        return res.data

    }
    catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Error al obtener el semáforo',
        })
    }
}
export const semaforoIncidentes = async (params) => {
    try {
        const res = await api.post(`${url_api}/exp-cliente/semaforo-incidente`, params)
        return res.data

    }
    catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Error al obtener el semáforo',
        })
    }
}
export const semaforoZonas = async () => {
    try {
        const res = await api.get(`${url_api}/exp-cliente/semaforo-descripcionZona`)
        return res.data

    }
    catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Error al obtener zonas',
        })
    }
}

export  const traerSemana = (fecha = new Date()) => {
        const anio = fecha.getFullYear();

        // Lunes de la semana 1 (la que contiene el 1 de enero)
        const primeroEnero = new Date(anio, 0, 1);

        const lunesSemana1 = new Date(primeroEnero);
        const dia = primeroEnero.getDay(); // 0=Dom, 1=Lun...

        if (dia === 0) {
            lunesSemana1.setDate(lunesSemana1.getDate() - 6);
        } else {
            lunesSemana1.setDate(lunesSemana1.getDate() - (dia - 1));
        }

        // Lunes de la semana de la fecha
        const lunes = new Date(fecha);
        const diaActual = lunes.getDay();

        if (diaActual === 0) {
            lunes.setDate(lunes.getDate() - 6);
        } else {
            lunes.setDate(lunes.getDate() - (diaActual - 1));
        }

        lunes.setHours(0, 0, 0, 0);

        // Retroceder a la semana anterior
        lunes.setDate(lunes.getDate() - 7);

        // Domingo
        const domingo = new Date(lunes);
        domingo.setDate(domingo.getDate() + 6);

        const semana = Math.floor((lunes - lunesSemana1) / (7 * 24 * 60 * 60 * 1000)) + 1;

        const formato = (f) => {
            const y = f.getFullYear();
            const m = String(f.getMonth() + 1).padStart(2, '0');
            const d = String(f.getDate()).padStart(2, '0');
            return `${y}-${m}-${d} 00:00:00.000`;
        };

        return {
            semana,
            fechaInicio: formato(lunes),
            fechaFin: formato(domingo)
        };

    }



       export function obtenerRangoAnioActual(fecha = new Date()) {
        const anio = fecha.getFullYear();

        // El primer día del rango es el lunes de la semana 1, que puede caer
        // en diciembre del año anterior (igual que traerRangoPorSemana).
        // Ej. 2026: 1 ene = jueves → lunesSemana1 = 29 dic 2025
        const primeroEnero = new Date(anio, 0, 1);
        const lunesSemana1 = new Date(primeroEnero);
        const diaAnio = primeroEnero.getDay();
        if (diaAnio === 0) {
            lunesSemana1.setDate(lunesSemana1.getDate() - 6);
        } else {
            lunesSemana1.setDate(lunesSemana1.getDate() - (diaAnio - 1));
        }
        const primerDia = [
            lunesSemana1.getFullYear(),
            String(lunesSemana1.getMonth() + 1).padStart(2, '0'),
            String(lunesSemana1.getDate()).padStart(2, '0')
        ].join('-');

        // Calcular el domingo de la semana anterior
        const lunes = new Date(fecha);
        const diaActual = lunes.getDay();
        if (diaActual === 0) {
            lunes.setDate(lunes.getDate() - 6);
        } else {
            lunes.setDate(lunes.getDate() - (diaActual - 1));
        }
        const domingoAnterior = new Date(lunes);
        domingoAnterior.setDate(domingoAnterior.getDate() - 1);

        const fechaFin = [
            domingoAnterior.getFullYear(),
            String(domingoAnterior.getMonth() + 1).padStart(2, '0'),
            String(domingoAnterior.getDate()).padStart(2, '0')
        ].join('-');

        return {
            fechaInicio: primerDia,
            fechaFin: fechaFin
        };
    }

/**
 * traerRangoPorSemana(semanaFin, n)
 * Devuelve el rango de semanas desde Math.max(1, semanaFin - n) hasta semanaFin
 * junto con sus fechas de inicio (lunes) y fin (domingo).
 *
 * Ejemplo: traerRangoPorSemana(6, 2) → semanas 4-6
 *          traerRangoPorSemana(2, 5) → semanas 1-2 (no puede bajar de la semana 1)
 */
export function traerRangoPorSemana(semanaFin, n, fecha = new Date()) {
    const anio = fecha.getFullYear();

    // ── Ancla: Lunes de la Semana 1 del año ──────────────────────────────────────
    // La semana 1 es la que CONTIENE el 1 de enero.
    // Su lunes puede caer en diciembre del año anterior (p. ej. si el 1 ene es
    // jueves, el lunes de esa semana es el 29 de diciembre del año previo).
    // JavaScript maneja setDate con valores ≤ 0 automáticamente retrocediendo
    // al mes/año anterior, por lo que NO hay que hacer ajuste manual de año.
    //
    // Ejemplo 2026: 1 ene = jueves (getDay=4)
    //   setDate(1 - (4-1)) → setDate(-2) → 29 dic 2025  ✓
    const primeroEnero = new Date(anio, 0, 1);
    const lunesSemana1 = new Date(primeroEnero);
    const diaAnio = primeroEnero.getDay(); // 0=Dom, 1=Lun … 6=Sáb
    if (diaAnio === 0) {
        lunesSemana1.setDate(lunesSemana1.getDate() - 6);   // Dom → retrocede 6
    } else {
        lunesSemana1.setDate(lunesSemana1.getDate() - (diaAnio - 1)); // Lun=0, Mar=1 …
    }
    // Desde este punto lunesSemana1 puede ser en diciembre del año anterior. ✓

    // Semana inicio (no puede ser menor que 1)
    const semanaInicio = Math.max(1, semanaFin - n);

    // Lunes de semanaInicio (si semanaInicio=1 y lunesSemana1=29 dic, esto da 29 dic)
    const lunesInicio = new Date(lunesSemana1);
    lunesInicio.setDate(lunesInicio.getDate() + (semanaInicio - 1) * 7);

    // Domingo de semanaFin
    const lunesFin = new Date(lunesSemana1);
    lunesFin.setDate(lunesFin.getDate() + (semanaFin - 1) * 7);
    const domingoFin = new Date(lunesFin);
    domingoFin.setDate(domingoFin.getDate() + 6);

    const formato = (f) => {
        const y = f.getFullYear();  // Puede ser año anterior cuando semana 1 empieza en dic
        const m = String(f.getMonth() + 1).padStart(2, '0');
        const d = String(f.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    return {
        semanaInicio,
        semanaFin,
        fechaInicio: formato(lunesInicio),
        fechaFin: formato(domingoFin),
    };
}